<template>
<ion-menu v-if="showMenu()" type="overlay" side="start" id="app-menu" menu-id="app-menu" content-id="main-content"
      v-bind:class="{ 'custom-menu-open': customMenuOpen }" @ionWillOpen="menuWillOpenHandle()"
      @ionDidClose="menuDidCloseHandle"> 
      <ion-header v-if="menuVisible">
        <ion-toolbar translucent>
          <div class="menu-logo">
            <img class="menu-logo" :src="menuLogo" @error="handleImgError" />
          </div>
        </ion-toolbar>
      </ion-header>
      <ion-content v-if="menuVisible"> 
<ion-list>
  <ion-item v-for="item in menuItems" :key="item" @click="menuNavigation(item.Path)">
    <ion-label>{{ item.Label }}</ion-label>
  </ion-item>
</ion-list>
<ion-grid class="ion-padding-top">
          <ion-row>
            <ion-col v-if="settings.show_tutorial"><ion-row class="ion-justify-content-center">
                <ion-icon @click="menuNavigation('/tutorial')" :icon="book" size="large"
                  style="color: black !important" class="button"></ion-icon>
              </ion-row>
              <div class="flex justify-content-center align-items-center pt-1">
                <span class="text-10" >Tutorial</span>
              </div>
            </ion-col>
            <ion-col><ion-row class="ion-justify-content-center">
                <ion-icon @click="menuNavigation('/faq')" :icon="helpCircle" size="large"
                  style="color: black !important" class="button"></ion-icon>
              </ion-row>
              <div class="flex justify-content-center align-items-center pt-1">
                <span class="text-10">FAQ App</span>
              </div>
            </ion-col>
            <ion-col><ion-row class="ion-justify-content-center">
                <ion-icon @click="menuNavigation('/report')" :icon="flag" size="large"
                  style="color: black !important" class="button"></ion-icon>
              </ion-row>
              <div class="flex justify-content-center align-items-center pt-1">
                <span class="text-10">Help</span>
              </div>
            </ion-col>
            <ion-col><ion-row class="ion-justify-content-center">
                <ion-icon @click="logout" :icon="logOut" size="large" style="color: black !important" class="button"></ion-icon>
              </ion-row>
              <div class="flex justify-content-center align-items-center pt-1">
                <span class="text-10">Logout</span>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
        <p class="powered-by">
          Powered by<br /><img @click="whappyClick" src="/assets/img/logo-whappy-blue.png" @error="handleImgError" />
        </p>
</ion-content>
</ion-menu>

</template>

<script>
import {
  IonRow,
  IonCol,
  IonToolbar,
  IonHeader,
  IonButtons,
  IonButton,
  IonIcon,
  IonList,
  IonContent,
  IonTitle,
  IonMenu,
  IonLabel,
  IonItem,
  IonMenuButton,
  IonGrid,
  IonFooter,
} from "@ionic/vue";
import { fetchMenu } from "./menuService";

import {
  ellipsisVertical,
  close,
  eye,
  home,
  today,
  cog,
  airplane,
  book,
  helpCircle,
  flag,
  chevronDownOutline,
  notificationsOutline,
  chevronUpOutline,
  logOut,
  logoInstagram,
  logoFacebook,
  logoLinkedin,
} from "ionicons/icons";
import { mapActions, mapGetters } from "vuex";
import { menuController } from "@ionic/vue";
import CampaignService from "../common/mixins/Campaign";
import UserService from "../common/mixins/User";
import { useStore } from "vuex";
import { useGeneralStore } from "../stores/useGeneralStore";
import ApiService from "../common/service.api";
import { ref} from "vue";
import { useRoute } from "vue-router";
export default {
  props: {
    pageTitle: {},
    data: {
      type: Array,
      // required: true,
      default: () => [],
    },
  },
  data() {
    return {
      menuItems: [],
      menuLogo:'',
      whappyClientConfig: { name: "Demo" }, 
      close,
      customMenuOpen: false,
      menuVisible: true,
      campaignId: null,
    };
  },
  computed: {},
  mixins: [CampaignService, UserService],
  components: {
    IonRow,
    IonCol,
    IonToolbar,
    IonHeader,
    IonButtons,
    IonButton,
    IonIcon,
    IonTitle,
    IonMenu,
    IonLabel,
    IonItem,
    IonList,
    IonContent,
    IonMenuButton,
    IonGrid,
    IonFooter,
  },
  setup() {
    const store = useStore();
    const generalStore = useGeneralStore();
    const currentUser = store.getters["user/getUserData"];
    const campaignId = ref(null);
    const getOnBoardingCampaigns =
      store.getters["campaigns/getOnBoardingCampaigns"];

    return {
      currentUser,
      ellipsisVertical,
      getOnBoardingCampaigns,
      eye,
      home,
      today,
      cog,
      airplane,
      book,
      helpCircle,
      flag,
      logOut,
      chevronDownOutline,
      notificationsOutline,
      chevronUpOutline,
      logoInstagram,
      logoFacebook,
      logoLinkedin,
    };
  },
  async created() {
  const menu = await fetchMenu();
  const clientName = process.env.VUE_APP_WHAPPY_CLIENT;

  if (clientName === 'estasiprofumerie') {
    this.menuItems = menu.filter(item =>
      item.Label === 'Home' || item.Label === 'Profilo'
    );
  } else {
    this.menuItems = menu.filter(
      (item) =>
        item.Clients.includes(this.whappyClientConfig.name) || item.Clients.includes("all")
    );
  }
},


  methods: {
    async getLogo() {
  const companyId = localStorage.getItem("companyId");
  if (!companyId) return;

  try {
    let res = await ApiService.get(`/AppSetting/${companyId}`);
    this.menuLogo = res.data.LogoApp;
  } catch (error) {
    console.error("Error", error);
  }
},

    menuNavigation(path) {
      if (path.includes("Academy")) {
          useGeneralStore().setIsOnboarding(false);
          useGeneralStore().setIsAccademy(true);
          useGeneralStore().setAccademyPath(path);
        } else if (path.includes("boarding")) {
          useGeneralStore().setIsAccademy(false);
          useGeneralStore().setIsOnboarding(true);
        } else {
          useGeneralStore().setIsAccademy(false);
          useGeneralStore().setIsOnboarding(false);
          useGeneralStore().setAccademyPath("");
        }
  
      menuController.close("app-menu");
      this.$router.push(path);
      
    },
    ...mapGetters("campaigns", {
      getOnBoardingId: "getOnBoardingId",
      getOnBoardingCampaign: "getOnBoardingCampaign",
    }),
    ...mapActions("auth", {
      logoutUser: "logoutUser",
    }),


  async fetchCampaignId() {
      const route = useRoute();
      const { idCampaign } = route.params;
      console.log('id', idCampaign)
      console.log('parametro', route.params)
      
      if (!idCampaign || idCampaign === 'undefined') {
        console.warn('No valid campaign ID found in route params');
        return;
      }
      
      try {
        const response = await ApiService.get(`Journey/Get/${idCampaign}`);
        console.log('response headerr' ,response)
        const campaigns = response.data.map((i) => i.idCampaign);
        if (campaigns.length > 0) {
          this.campaignId = campaigns[0];
        }
      } catch (error) {
        console.error("Error fetching campaign ID:", error);
      }
    },


    async handleGetCampaign() {
      let result = []
      try {
        result = await ApiService.get("CampaignManager/GetUserCampaings/");
      } catch (error) {
        console.log('error', error);
      }

    this.campaignList = result.data.filter((x) => {
        return x.id_tipo_campagna === 4
      }); 
    },
    openLink(link) {
      window.open(link, "_blank");
    },
    handleImgError() {
      return "https://placehold.co/300x300?text=MartechRevolution";
    },

    gotoInstagram() {
      window.open("https://www.instagram.com/yoube.privateskin/", "_blank");
    },

    gotoFacebook() {
      window.open("https://www.facebook.com/yoube.privateskin", "_blank");
    },

    gotoLinkedin() {
      window.open(
        "https://www.linkedin.com/company/yoube-cosmetics/",
        "_blank"
      );
    },

    toggleClientiCollapsed() {
      this.clientiCollapsed = !this.clientiCollapsed;
    },

    showItemInfo(event) {
      this.showPersonalSetupModal = true;
      this.modalData = { ...event };
    },
    personalSetup_checkbox(event) {
      let start = this.personalSetup_totPerc;

      if (event.value) {
        this.personalSetup_totPerc = this.personalSetup_totPerc + event.perc;
      } else {
        this.personalSetup_totPerc = this.personalSetup_totPerc - event.perc;
      }

      this.animateValue(
        "personal-setup-totperc",
        start,
        this.personalSetup_totPerc,
        200
      );

      let valoreFinaleStart = this.personalSetup_valoreFinale;

      this.personalSetup_valoreFinale = (
        (this.premioTotale / 100) *
        this.personalSetup_totPerc
      ).toFixed(0);

      this.animateValue(
        "valore-finale",
        valoreFinaleStart,
        this.personalSetup_valoreFinale,
        200
      );
    },

    animateValue(id, start, end, duration) {
      start = parseInt(start);
      end = parseInt(end);
      if (start === end) return;
      var range = (end - start) * 10;
      var current = start;
      var increment = end > start ? 1 : -1;
      var stepTime = Math.abs(Math.floor(duration / range));
      var obj = document.querySelector("#" + id);
      var timer = setInterval(function () {
        current = parseInt(current) + increment;
        obj.innerHTML = current;
        if (current == end) {
          clearInterval(timer);
        }
      }, stepTime);
    },
    whappyClick() {
      this.$root.externalLinkBlank("https://www.whappy.it/");
    },
    showMenu() {
      return this.isLogged();
    },
    menuWillOpenHandle() {
      this.customMenuOpen = true;
    },
    menuDidCloseHandle() {
      this.customMenuOpen = false;
    },

    async logout() {
      await this.logoutUser();
      window.location.reload();
      this.$router.push("/login");
    },
  },

 async  mounted() {
    this.fetchCampaignId();
    this.handleGetCampaign()
    await this.getLogo(); 
  },
};


</script>

<style lang="scss" scoped>
ion-toolbar {
  color: var(--ion-color-primary);
}

ion-button.sign-out {
  font-size: 17px;
  font-weight: 500;
  margin-left: 5px;
  float: left;
  --color: #ffffff;
}

.ellipsis {
  color: #ffffff;
}

ion-title.logo {
  font-weight: 900;
  font-size: 25px;
}

ion-menu {
  &::part(container) {
    transition: all 0.1s ease-in;
    left: -304px;
  }

  &.custom-menu-open::part(container) {
    left: 0;
  }
}

.menu-logo {
  text-align: center;

  img {
    max-height: 100px;
    padding: 5px 5px 0 5px;
    margin: 0 auto;
  }
}

.powered-by {
  display: block;
  margin: 40px 0;
  font-size: 12px;
  padding: 16px;
  text-align: start;

  img {
    margin-top: 20px;
    margin-left: 50px;
    max-height: 30px;
  }
}

.modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  visibility: hidden;
  transform: scale(1.1);
  transition: visibility 0s linear 0.25s, opacity 0.25s 0s, transform 0.25s;
  z-index: 1000;
}

.modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  color: black;
  padding: 2rem 1.5rem;
  width: 95%;
  height: 80%;
  border-radius: 0.5rem;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr repeat(2, 2fr) 5fr 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  overflow-y: scroll;
}

.show-modal {
  opacity: 1;
  visibility: visible;
  transform: scale(1);
  transition: visibility 0s linear 0s, opacity 0.25s 0s, transform 0.25s;
}

.personalsetup-items {
  width: 95%;
  padding: 1rem 2rem;
  margin: 1rem auto;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03), 0px 0px 2px rgba(0, 0, 0, 0.06),
    0px 2px 6px rgba(0, 0, 0, 0.12);
  border-radius: 15px;

  &-titolo {
    font-weight: bold;
  }

  &-list {
    padding: 1rem 0;
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    ion-icon {
      font-size: 1.2rem;
      margin-right: 1rem;
    }

    &-label {
      font-size: 1rem;
    }
  }
}

ion-icon {
  border: 1px solid var(--ion-color-primary);
  border-radius: 50%;
  background: var(--ion-color-primary);
  color: #fff !important;
  padding: 0.6rem;
}

.no-bg {
  background: none;
  border: none;
  color: black !important;
}

.button {
  background: var(--HCardBg) !important;
  border: none;
  color: black
}
</style>
